import { Search } from 'icons';
import { rem } from 'polished';
import styled from 'styled-components';
import { BodyText } from '@unmind/design-system';

export const EmptyContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: ${rem(8)};
  margin: ${rem(32)} auto 0;
  padding: ${rem(48)} ${rem(32)};
  background-color: ${({ theme }) => theme.colors.background.secondary};
  border-radius: ${rem(16)};
  text-align: center;
`;

export const MagIcon = styled(Search).attrs(({ theme }) => ({
  primaryColor: theme.colors.text.primary,
  secondaryColor: theme.colors.text.primary,
}))`
  height: ${rem(24)};
  width: ${rem(24)};
  path {
    fill-opacity: 1;
  }
`;

export const EmptyTitle = styled(BodyText).attrs(({ theme }) => ({
  sizes: [
    theme.typography.fontSizes.fontSize16,
    theme.typography.fontSizes.fontSize18,
  ],
}))`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const EmptyTitleContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: ${rem(8)};
`;

export const EmptySubtitle = styled(BodyText).attrs(({ theme }) => ({
  sizes: [
    theme.typography.fontSizes.fontSize14,
    theme.typography.fontSizes.fontSize16,
  ],
}))`
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const EmptyActionContainer = styled.div`
  margin-top: ${rem(16)};
`;
